module.exports = __webpack_public_path__ + "static/media/biteship-woo.30d1f013.png";